var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"brand-logo-img",attrs:{"src":"/logo.png","alt":"My PODA logo","height":"24","width":"24"}})}
var staticRenderFns = []

export { render, staticRenderFns }